export default {
// To use it like:
// buildURLQuery(paramsObj);    => 'images_only=true&folder=My%20Photos'
  buildURLQuery(obj) {
    return Object.entries(obj)
      .filter(([_, value]) => typeof value !== 'undefined')
      .map((pair) => pair.map(encodeURIComponent).join('='))
      .join('&');
  },
};
